import React from 'react';

export interface IFormAccessContext {
  readOnly: boolean;
}

const FormAccessContext = React.createContext<IFormAccessContext>({ readOnly: false });

export default FormAccessContext;
